import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { navigation as navigationType } from 'lib/CustomPropTypes';

const block = 'headerPackageNavigation';

const Navigation = (props) => {
  const { navigation, styleOverride } = props;

  const wrapperClasses = classNames(
    block,
    'font-title',
    styleOverride.linkListWrapper,
  );

  const listClasses = classNames(
    styleOverride.linkList,
  );

  const itemClasses = classNames(
    styleOverride.linkListItem,
  );

  if (navigation && navigation.length) {
    return (
      <div className={wrapperClasses}>
        <ul className={listClasses}>
          {props.navigation.map((item) => (
            <li
              key={item.linkTitle}
              className={itemClasses}
            >
              <a href={item.linkUrl}>{item.linkTitle}</a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return null;
};

Navigation.propTypes = {
  navigation: navigationType,
  styleOverride: PropTypes.shape({
    linkListWrapper: PropTypes.string,
    linkList: PropTypes.string,
    linkListItem: PropTypes.string,
  }),
};

Navigation.defaultProps = {
  navigation: [],
  styleOverride: PropTypes.shape({
    linkListWrapper: null,
    linkList: null,
    linkListItem: null,
  }),
};

export default Navigation;
